import React, { Component } from 'react'
// import PropTypes from 'prop-types'

export default class InfoSectionDescription2 extends Component {
  // static propTypes = {
  //   prop: PropTypes
  // }

  render() {
    return (
      <span>
        Over the years my development stack has changed.  I started out using a technology stack which included: Gulp, Sublime Text, Wordpress, and static websites.  Then I moved to something like: Webpack, Atom, Wordpress, Node JS, and Angular.  Currently my tech stack includes: Visual Studio Code, React JS, <a href="https://www.gatsbyjs.org" alt="A blazing fast javascript static site generator for react">Gatsby JS</a>, React Native, and consuming REST API's.
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/config/custom-components/InfoSectionDescription2.js